import React, { PropsWithChildren } from "react"

interface GridLayoutProps {
  empty?: boolean
  label: string
  children: React.ReactNode
}

export const GridLayout = ({
  empty,
  label,
  children,
}: PropsWithChildren<GridLayoutProps>) => {
  return (
    <div
      role="region"
      aria-label={label}
      className={
        empty
          ? "grid flex-1 grid-cols-1 grid-rows-1 gap-lg p-lg pb-0"
          : "grid grid-cols-[repeat(auto-fill,minmax(270px,1fr))] gap-lg p-lg pb-0"
      }
    >
      {children}
    </div>
  )
}
